<template>
  <q-select
    v-if="allCurrentTags.length > 0"
    :model-value="modelValue"
    transition-duration="100"
    dense
    filled
    clearable
    label="Filter by Tags"
    use-input
    input-debounce="0"
    input-class="col-2"
    :options="options"
    style="width: 250px"
    @filter="filterTags"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template #prepend>
      <q-icon name="label" />
    </template>
    <template #selected>
      <span class="ellipsis" style="max-width: 80px">
        {{ modelValue }}
      </span>
    </template>
  </q-select>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'FilterByTags',
  props: {
    allCurrentTags: {
      type: Array as PropType<string[]>,
      required: true
    },
    modelValue: {
      type: [String, null] as PropType<string, null>,
      required: true
    }
  },
  emits: ['update:model-value'],
  data() {
    return {
      options: [] as string[]
    }
  },
  methods: {
    filterTags(val: string, updateFn: (cb: () => void) => void) {
      // updateFn is emitted by quasar and can be utilized to handle updates on nextTick
      if (val === '') {
        updateFn(() => {
          this.options = this.allCurrentTags
        })
        return
      }

      updateFn(() => {
        const needle = val.toLowerCase()
        this.options = this.allCurrentTags.filter((tag: string) =>
          tag.toLowerCase().includes(needle)
        )
      })
    }
  }
}
</script>
